import React, { useState, useEffect } from 'react';
import { Table, Button, Space, message, Avatar, Checkbox, List, Badge, Row, Col, Popconfirm, Input } from 'antd'; // Dodat Input
import { 
  PlusOutlined, 
  DeleteOutlined, 
  SendOutlined, 
  PictureOutlined, 
  EditOutlined,
  PlaySquareOutlined,
  SearchOutlined // Dodata ikonica
} from '@ant-design/icons';
import axios from 'axios';
import MobileCreatePlaylistModal from './MobileCreatePlaylistModal';

const MobilePlaylist = () => {
  const [playlists, setPlaylists] = useState([]);
  const [mediaFiles, setMediaFiles] = useState([]);
  const [boxes, setBoxes] = useState([]); 
  const [loading, setLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [sendModalVisible, setSendModalVisible] = useState(false);
  
  const [selectedItems, setSelectedItems] = useState([]);
  const [creating, setCreating] = useState(false);
  const [sending, setSending] = useState(false);
  const [selectedPlaylistId, setSelectedPlaylistId] = useState(null);
  const [editingPlaylist, setEditingPlaylist] = useState(null);
  const [selectedBoxIds, setSelectedBoxIds] = useState([]);
  const [boxSearchText, setBoxSearchText] = useState(''); // State za pretragu boxova

  const fetchPlaylists = async () => {
    try {
      const response = await axios.get('/api/box/playlists/');
      setPlaylists(response.data);
    } catch (error) { console.error('Error:', error); }
  };

  const fetchMedia = async () => {
    try {
      const response = await axios.get('/api/box/media/');
      setMediaFiles(response.data);
    } catch (error) { console.error('Error:', error); } finally { setLoading(false); }
  };

  const fetchBoxes = async () => {
    try {
      const response = await axios.get('/api/box/list/');
      setBoxes(response.data);
    } catch (error) { console.error('Error:', error); }
  };

  useEffect(() => {
    fetchPlaylists();
    fetchMedia();
    fetchBoxes();
  }, []);

  // Filtriranje boxova u modalu
  const filteredBoxes = boxes.filter(box => {
    const name = (box.box_name || box.box_id || '').toString().toLowerCase();
    return name.includes(boxSearchText.toLowerCase());
  });

  const openEditModal = (playlist) => {
    setEditingPlaylist(playlist);
    const itemsForEditor = (playlist.items || []).map(item => ({
      ...item.media_details,
      id: `${item.media_details.id}-${Math.random().toString(36).substr(2, 5)}`,
      duration: item.duration || 5
    }));
    setSelectedItems(itemsForEditor);
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setEditingPlaylist(null);
    setSelectedItems([]);
  };

  const handleSavePlaylist = async (name, resolution, items) => {
    if (!name.trim()) { message.error('Please enter a name'); return; }
    setCreating(true);
    try {
      if (editingPlaylist) {
        await axios.put(`/api/box/playlists/${editingPlaylist.id}/`, { name, resolution, items });
        message.success('Playlist updated');
      } else {
        await axios.post('/api/box/playlists/', { name, resolution, items });
        message.success('Playlist created');
      }
      closeModal();
      fetchPlaylists();
    } catch (error) { message.error('Error saving playlist'); } finally { setCreating(false); }
  };

  const handleSendToBox = async () => {
    if (selectedBoxIds.length === 0) { message.warning('Please select at least one box'); return; }
    setSending(true);
    try {
      await axios.post('/api/box/deploy-playlist/', { playlist_id: selectedPlaylistId, box_ids: selectedBoxIds });
      message.success('Deployed successfully!');
      setSendModalVisible(false);
      setSelectedBoxIds([]);
      setBoxSearchText(''); // Resetuj pretragu
    } catch (error) { message.error('Deployment failed'); } finally { setSending(false); }
  };

  const deletePlaylist = async (id) => {
    try {
      await axios.delete(`/api/box/playlists/${id}/`);
      message.success('Playlist deleted');
      if (selectedPlaylistId === id) setSelectedPlaylistId(null);
      fetchPlaylists();
    } catch (error) { message.error('Error deleting playlist'); }
  };

  const columns = [
    {
      title: 'Playlist',
      key: 'playlist',
      render: (record) => (
        <div className="m-mini-card">
          <div className="m-card-col thumb-info">
            {record.items?.[0]?.media_details?.thumbnail ? (
              <Avatar src={`https://escreen.stand.ledscreen.rs/media/${record.items[0].media_details.thumbnail}`} shape="square" size={50} className="media-avatar" />
            ) : (
              <Avatar icon={<PictureOutlined />} shape="square" size={50} className="media-avatar video-bg" />
            )}
          </div>

          <div className="m-card-col main-info">
            <div className="box-name-text">{record.name}</div>
            <div className="status-label" style={{ color: '#34d399' }}>
              {record.items?.length || 0} FILES
            </div>
          </div>

          <div className="m-card-col action-btn">
            <div className="m-pl-actions">
              <Button 
                size="middle" 
                icon={<SendOutlined />}
                className="view-btn-dark"
                style={selectedPlaylistId === record.id ? { background: '#10b981 !important', color: 'white !important', border: 'none' } : {}}
                onClick={() => setSelectedPlaylistId(record.id === selectedPlaylistId ? null : record.id)}
              />
              <Button size="middle" icon={<EditOutlined />} onClick={() => openEditModal(record)} className="view-btn-dark edit-style" />
              <Popconfirm title="Delete?" onConfirm={() => deletePlaylist(record.id)}>
                <Button size="middle" icon={<DeleteOutlined />} className="view-btn-dark del-style" />
              </Popconfirm>
            </div>
          </div>
        </div>
      )
    }
  ];

  return (
    <div className="mobile-dashboard-wrapper">
      <Row gutter={[8, 8]} style={{ marginBottom: '15px' }}>
        <Col span={selectedPlaylistId ? 14 : 24}>
          <div className="st-box" style={{ borderBottomColor: '#3b82f6' }}>
             <Space>
               <PlaySquareOutlined style={{ color: '#3b82f6', fontSize: '20px' }} />
               <span style={{ color: '#ffffff', fontSize: '15px', fontWeight: 'bold' }}>Total:</span>
               <span style={{ color: 'white', fontWeight: '900', fontSize: '22px' }}>{playlists.length}</span>
             </Space>
          </div>
        </Col>
        {selectedPlaylistId && (
          <Col span={10}>
            <Button block type="primary" icon={<SendOutlined />} onClick={() => setSendModalVisible(true)} style={{ background: '#10b981', height: '100%', borderRadius: '8px', border: 'none', fontWeight: 'bold' }}>SEND</Button>
          </Col>
        )}
        <Col span={24}>
          <div className="st-box" style={{ borderBottomColor: '#3b82f6', padding: '0' }}>
            <Button block type="dashed" icon={<PlusOutlined />} onClick={() => setModalVisible(true)} style={{ background: 'transparent', color: '#3b82f6', border: 'none', height: '45px', fontWeight: 'bold' }}>CREATE NEW PLAYLIST</Button>
          </div>
        </Col>
      </Row>

      <Table dataSource={playlists} columns={columns} rowKey="id" loading={loading} pagination={false} />

      <MobileCreatePlaylistModal 
        isVisible={modalVisible} 
        onClose={closeModal} 
        onCreate={handleSavePlaylist} 
        mediaFiles={mediaFiles} 
        selectedItems={selectedItems} 
        setSelectedItems={setSelectedItems} 
        loading={creating} 
        editingPlaylist={editingPlaylist} 
      />

      {sendModalVisible && (
        <div className="m-modal-custom">
          <div className="m-modal-content" style={{ width: '90%' }}>
            <div className="m-modal-header">
              <span style={{ color: 'white', fontWeight: 'bold' }}>Send to Boxes</span>
              <Button type="text" onClick={() => { setSendModalVisible(false); setBoxSearchText(''); }} style={{ color: 'white' }}>X</Button>
            </div>
            
            {/* SEARCH UNUTAR MODALA */}
            <div style={{ padding: '10px 15px', background: '#1e293b' }}>
              <Input
                placeholder="Traži box..."
                prefix={<SearchOutlined style={{ color: '#94a3b8' }} />}
                value={boxSearchText}
                onChange={e => setBoxSearchText(e.target.value)}
                className="m-search-input-modal"
                allowClear
              />
            </div>

            <div className="m-modal-body">
              <List
                dataSource={filteredBoxes}
                renderItem={box => (
                  <List.Item style={{ borderBottom: '1px solid #334155', padding: '10px 0' }}>
                    <Checkbox 
                      style={{ width: '100%', color: 'white' }}
                      onChange={(e) => {
                        if (e.target.checked) setSelectedBoxIds([...selectedBoxIds, box.id]);
                        else setSelectedBoxIds(selectedBoxIds.filter(id => id !== box.id));
                      }}
                      checked={selectedBoxIds.includes(box.id)}
                    >
                      <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%', alignItems: 'center' }}>
                        <span style={{ fontSize: '13px' }}>{box.box_name || box.box_id}</span>
                        <Badge status={box.status === 'online' ? 'success' : 'error'} />
                      </div>
                    </Checkbox>
                  </List.Item>
                )}
              />
              <Button 
                block 
                type="primary" 
                onClick={handleSendToBox} 
                loading={sending} 
                disabled={selectedBoxIds.length === 0}
                style={{ background: '#3b82f6', marginTop: '20px', height: '45px', fontWeight: 'bold' }}
              >
                SEND TO {selectedBoxIds.length} BOXES
              </Button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .mobile-dashboard-wrapper { padding-bottom: 20px; }
        .st-box { background: #1e293b; padding: 15px; border-radius: 8px; border: 1px solid #334155; border-bottom: 5px solid; display: flex; justify-content: center; align-items: center; }
        
        /* STIL ZA SEARCH U MODALU */
        .m-search-input-modal {
          background: #0f172a !important;
          border: 1px solid #334155 !important;
          color: white !important;
          border-radius: 6px !important;
        }
        .m-search-input-modal input {
          background: transparent !important;
          color: white !important;
        }

        .ant-table { background: transparent !important; }
        .ant-table-thead { display: none !important; }
        .ant-table-tbody > tr > td { border: none !important; padding: 0 0 10px 0 !important; background: transparent !important; }

        .m-mini-card { 
          background: #1e293b; 
          border: 1px solid #475569; 
          border-radius: 10px; 
          padding: 10px; 
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .m-card-col { display: flex; flex-direction: column; min-width: 0; }
        .thumb-info { flex: 0 0 auto; }
        .main-info { flex: 2; margin-left: 4px; }
        .action-btn { flex: 0 0 auto; }

        .media-avatar { border: 1px solid #334155; border-radius: 6px !important; }
        .video-bg { background: #0f172a !important; }

        .box-name-text { color: white !important; font-weight: 700; font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        .status-label { font-size: 10px; font-weight: 900; letter-spacing: 0.5px; margin-top: 2px; }

        .m-pl-actions { display: flex; gap: 6px; }

        .view-btn-dark {
          background: #1e293b !important; 
          color: #94a3b8 !important; 
          border: 1px solid #334155 !important; 
          border-radius: 6px !important; 
          font-weight: bold !important; 
          height: 34px !important;
          width: 34px !important;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 0 !important;
        }
        .edit-style { color: #60a5fa !important; }
        .del-style { color: #ef4444 !important; }

        .m-modal-custom { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.85); z-index: 2000; display: flex; align-items: center; justify-content: center; }
        .m-modal-content { background: #1e293b; border-radius: 12px; border: 1px solid #334155; overflow: hidden; }
        .m-modal-header { padding: 15px; border-bottom: 1px solid #334155; display: flex; justify-content: space-between; align-items: center; }
        .m-modal-body { padding: 15px; max-height: 60vh; overflow-y: auto; }
      `}</style>
    </div>
  );
};

export default MobilePlaylist;